<!-- <template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	import {
		getToken,
		removeToken
	} from '@/utils/auth'
	import {
		getCurrentUser
	} from "@/api/user"
	export default {
		name: 'App',
		mounted() {
			if(getToken()){
				this.$socketPublic.dispatch('webSocketInit'); //初始化ws
			}
		},
		methods: {
		},
	}
</script> -->
<template>
	<div id="app">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>
<script>

import {
	removeToken,
	getToken,
} from '@/utils/auth'

// 用于标记会话是否存活的key
const SESSION_ALIVE_KEY = 'app_session_alive';

export default {
	name: 'App',
	created() {
		// 检查是否是新会话（关闭浏览器/标签后重新打开）
		// sessionStorage 在关闭浏览器/标签时会被清除，刷新时会保留
		const isSessionAlive = sessionStorage.getItem(SESSION_ALIVE_KEY) === 'true';
		
		if (!isSessionAlive) {
			// 新会话：说明是关闭浏览器/标签后重新打开的
			// 执行清理操作
			this.clearCacheAndCloseSocket();
		}
		
		// 设置会话存活标记
		sessionStorage.setItem(SESSION_ALIVE_KEY, 'true');
	},
	mounted() {
		this.$socketPublic.dispatch('webSocketInit'); //初始化ws
	},
	beforeDestroy() {
		// 组件销毁时关闭 WebSocket（页面内导航时）
		// 注意：这不会在关闭浏览器/标签时触发
	},
	methods: {
		// 清理函数：清除缓存和关闭socket
		clearCacheAndCloseSocket() {
			// 关闭 WebSocket
			if (this.$socketPublic) {
				this.$socketPublic.dispatch('closeWebSocket');
			}
			// 清除 token
			removeToken();
		}
	}
}
</script>
<style>
	body {
		/* -webkit-user-select: none;
		-moz-user-select: none;
		user-select: none;
		-ms-user-select: none; */
	}

	::-webkit-scrollbar {
		-webkit-appearance: none;
		width: 6px;
		height: 6px;
	}

	::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, 0.1);
		border-radius: 0;
	}

	::-webkit-scrollbar-thumb {
		cursor: pointer;
		border-radius: 5px;
		background: rgba(0, 0, 0, 0.15);
		transition: color 0.2s ease;
	}

	::-webkit-scrollbar-thumb:hover {
		background: rgba(0, 0, 0, 0.3);
	}

	::-moz-scrollbar {
		-webkit-appearance: none;
		width: 6px;
		height: 6px;
	}

	::-moz-scrollbar-track {
		background: rgba(0, 0, 0, 0.1);
		border-radius: 0;
	}

	::-moz-scrollbar-thumb {
		cursor: pointer;
		border-radius: 5px;
		background: rgba(0, 0, 0, 0.15);
		transition: color 0.2s ease;
	}

	::-moz-scrollbar-thumb:hover {
		background: rgba(0, 0, 0, 0.3);
	}

	textarea::placeholder {
		color: #000 !important;
	}

	input::placeholder {
		color: #545454 !important;
	}
</style>
<style lang="scss">
	@import url("@/assets/style/common.scss");
</style>